<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2024-06-06 08:49:04
 * @LastEditTime : 2025-12-22 14:46:42
 * @LastEditors  : yangxr
 * @Description  : 余料处理
 * @FilePath     : \icps_fb\src\views\platform\ICPS\smart\schedul\surplusMaterials.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <div class="tabtop" style="margin: 0px 0px 10px">
        <div @click="choose(1)">
          <div :class="currenindex == 1 ? 'active' : 'text'">未处理</div>
        </div>
        <div @click="choose(3)">
          <div :class="currenindex == 3 ? 'active' : 'text'">已处理</div>
        </div>
      </div>
      <el-main style="display: flex">
        <div>
          <el-collapse-transition>
            <div v-show="showCardNav">
              <div class="search">
                <span style="margin-left: 10px">
                  <span style="margin-right: 12px">车牌号</span>
                  <el-input v-model="tableParam.carNo" style="width: 100px" clearable />
                </span>
                <span style="margin-left: 10px">
                  <span style="margin-right: 12px">站点名称</span>
                  <el-select v-model="tableParam.stationId" style="width: 120px" filterable>
                    <el-option v-for="item in pointIdListArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </span>
                <span style="margin-left: 10px">
                  <span style="margin-right: 12px">浇筑部位</span>
                  <el-input v-model="tableParam.structuralParts" style="width: 100px" clearable />
                </span>
                <span style="margin-left: 10px">
                  <span style="margin-right: 12px">生产线</span>
                  <el-input v-model="tableParam.proLine" style="width: 100px" clearable />
                </span>
                <span style="margin-left: 10px">
                  <span style="margin-right: 12px">产品</span>
                  <el-input v-model="tableParam.productName" style="width: 100px" clearable />
                </span>
                <span style="margin-left: 10px">
                  <span style="margin-right: 12px">浇筑时间</span>
                  <el-date-picker
                    v-model="startTimDateEndTimDate"
                    type="datetimerange"
                    unlink-panels
                    value-format="yyyy-MM-dd HH:mm:ss"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    style="width:340px"
                    @change="(tableParam.createTime = startTimDateEndTimDate ? startTimDateEndTimDate[0] : ''), (tableParam.updateTime = startTimDateEndTimDate ? startTimDateEndTimDate[1] : '')"
                  ></el-date-picker>
                </span>
                <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
                <el-button style="margin-left: 12px" class="bottom_three" @click="load()">导 出</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card">
            <div class="card_nav">
              <div></div>
              <div>
                <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 5px">
                  <el-link :underline="false">
                    <span class="el-icon--left">
                      <i class="iconfont iconicon_button_filtrate"></i>
                    </span>
                    筛选
                  </el-link>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) in table" :key="index">
                      <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :height="screenHeight - 460" :data="tableData" tooltip-effect="dark">
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width" :fixed="item.label == '操作' ? 'right' : false">
                    <template slot-scope="scope">
                      <span v-if="item.label == '数据来源'">
                        <span>{{ dataTypeList[scope.row.dataType*1] }}</span>
                      </span>
                      <span v-else-if="item.label == '处理类型'">
                        <span>{{ ["", "转料", "报废", "积鼓", "翻出"][scope.row.exceptionType] }}</span>
                      </span>
                      <span v-else-if="item.label == '余料状态'">
                        <span>{{ ["", "待处理", "待提交", "已处理"][scope.row.surplusStatus ? scope.row.surplusStatus : 1] }}</span>
                      </span>
                      <span v-else-if="item.label == '操作'">
                        <el-button class="bottom_all_two" size="mini" @click="handleClick(scope.row)">{{ currenindex === 1 ? "处理" : "查看" }}</el-button>
                        <el-button v-if="scope.row.surplusStatus == 2 && currenindex === 1" class="bottom_two" size="mini" style="margin-left: 10px;" @click="cancle(scope.row)">取消</el-button>
                        <el-button v-if="scope.row.exceptionType != 4 && currenindex === 3" class="bottom_two" size="mini" style="margin-left: 10px;" @click="cancle(scope.row)">取消</el-button>
                      </span>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="gettableData()"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 余料处理 -->
    <el-dialog v-dialogDrag :visible.sync="look3Type" width="75%" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">余料处理</span>
      <div class="dialoginfo">
        <el-form ref="formData4" :disabled="currenindex === 3" :rules="rules4" :inline="true" :model="formData4" label-width="110px">
          <el-form-item prop="exceptionType" label="类型">
            <el-select v-model="formData4.exceptionType" placeholder="请选择">
              <el-option label="转料" :value="1"></el-option>
              <el-option label="报废" :value="2"></el-option>
              <el-option label="积鼓" :value="3"></el-option>
              <el-option label="翻出" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="formData4.exceptionType == 1" prop="stationId" label="站点">
            <span slot="label" style="color: #ff0000">转料站点</span>
            <el-select
              ref="selectstationId"
              v-model="formData4.stationId"
              :disabled="isTurnStation || list2Info.surplusStatus === 2"
              placeholder="请选择"
              @change="
                $nextTick(() => {
                  formData4.station = $refs.selectstationId.selectedLabel;
                  radio = '';
                  formData4.lineId = '';
                  formData4.lineName = '';
                  queryLineByStation(formData4.stationId);
                })
              "
            >
              <el-option v-for="(v, k) in pointIdListArr" :key="k" :label="v.name" :value="v.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="formData4.exceptionType == 1 && (formData4.stationId === list2Info.productionSiteId || isTurnStation)" prop="queueUpLineGroup" label="生产线">
            <span slot="label" style="color: #ff0000">生产线</span>
            <el-select
              ref="queueUpLineGroup"
              v-model="formData4.queueUpLineGroup"
              placeholder="请选择"
              @change="
                $nextTick(() => {
                  formData4.queueUpLine = $refs.queueUpLineGroup.selectedLabel;
                })
              "
            >
              <el-option v-for="(v, k) in lineGroupList" :key="k" :label="v.name" :value="v.groupNum"></el-option>
            </el-select>
          </el-form-item>
          <div>
            <el-form-item v-if="formData4.exceptionType == 4 || formData4.exceptionType == 1" prop="residueNum" label="余料量">
              <span slot="label">余料量</span>
              <el-input v-model="formData4.residueNum" disabled :rows="5" resize="none" style="width: 240px" clearable>
                <template slot="append">方</template>
              </el-input>
            </el-form-item>
            <el-form-item v-if="formData4.exceptionType == 1" prop="transitionResionId" label="余料量">
              <span slot="label" style="color: #ff0000">转场原因</span>
              <el-select
              ref="transitionResionId"
              v-model="formData4.transitionResionId"
              placeholder="请选择"
              @change="
                $nextTick(() => {
                  formData4.transitionResion = $refs.transitionResionId.selectedLabel;
                })
              "
            >
              <el-option v-for="(v, k) in turnReasonList" :key="k" :label="v.itemName" :value="v.id"></el-option>
            </el-select>
            </el-form-item>
          </div>
          <el-form-item v-if="formData4.exceptionType == 1" prop="turnNum" label="转料量">
            <span slot="label" style="color: #ff0000">转料量</span>
            <el-input v-model="formData4.turnNum" :rows="5" resize="none" style="width: 240px" clearable>
              <template slot="append">方</template>
            </el-input>
          </el-form-item>

          <div v-if="formData4.exceptionType == 4">
            <el-form-item prop="overNum" label="翻出量">
              <span slot="label">翻出量</span>
              <el-input v-model="formData4.overNum" :rows="5" resize="none" style="width: 240px" clearable> </el-input>
            </el-form-item>
          </div>
          <el-form-item v-if="formData4.exceptionType == 1" label="备注" prop="remark">
            <el-input v-model="formData4.remark"></el-input>
          </el-form-item>
          <div v-else-if="formData4.exceptionType > 1">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="formData4.remark" type="textarea" style="width: 240px"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div v-if="formData4.exceptionType == 1 && (formData4.stationId === list2Info.productionSiteId || isTurnStation)">
          <div style="font-size: 24px">计划列表</div>
          <div v-if="currenindex === 1" class="search" >
            <span style="margin-bottom: 10px; display: inline-block">
              <span style="margin-right: 12px">接收工程</span>
              <el-input v-model="formData4.engineeringName" style="width: 150px" placeholder="请输入" />
            </span>
            <span style="margin-left: 24px">
              <span style="margin-right: 12px">浇筑部位</span>
              <el-input v-model="formData4.structuralParts" style="width: 150px"></el-input>
            </span>
            <span style="margin-left: 24px">
              <span style="margin-right: 12px">产品名称</span>
              <el-input v-model="formData4.productName" style="width: 150px"></el-input>
            </span>
            <span style="margin-left: 24px">
              <span style="margin-right: 12px">浇筑日期</span>
              <el-date-picker v-model="formData4.pouringTime" type="date" unlink-panels style="width: 180px" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </span>
            <el-button class="bottom_all_two" style="margin-left: 24px" @click="getPlanPage(1)">查询计划</el-button>
          </div>
          <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="surplusList2" tooltip-effect="dark">
            <el-table-column width="55">
              <template slot-scope="scope">
                <el-radio v-model="radio" :label="scope.row" @change="radioFun(scope.row)">{{ "" }}</el-radio>
              </template>
            </el-table-column>
            <el-table-column label="订单号" align="center" prop="orderNo"></el-table-column>
            <el-table-column label="工程名称" align="center" prop="engineeringName"></el-table-column>
            <el-table-column label="浇筑部位" align="center" prop="structuralParts"></el-table-column>
            <el-table-column label="产品名称" align="center" prop="productName"></el-table-column>
            <el-table-column label="浇筑时间" align="center" prop="pouringTime"></el-table-column>
          </el-table>
          <el-pagination :current-page.sync="surplusPage2" :page-size="5" layout="prev,pager,next" :total="surplusTotal2" @current-change="page => this.getPlanPage(page)"></el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look3Type = false">取 消</el-button>
        <el-button v-show="currenindex !== 3" class="bottom_all" style="margin-left: 24px" @click="submit3()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import mixin from "@/mixins/ICPSmixin.js";
import { getUserInfo } from "@/utils/auth.js";
import { querySurplusLogisticsPage, get_engineering_list,saveTransferMaterials,saveOverMaterials, saveOther, getPlanByCode,cancelHandle,Download } from "@/api/smart/schedul/j.js";
import { getPlanPage } from "@/api/smart/schedul/d";
import { queryLineGroup } from "@/api/smart/productTransport_outside.js";
import { getUserAutList,getDicType } from "@/api/common.js";
export default {
  components: {},
  mixins: [mixin],
  data() {
    let stationId = (rule, value, callback) => {
      if (!value && this.formData4.exceptionType == 1) {
        return callback(new Error("请选择站点"));
      } else {
        callback();
      }
    };
    let transitionResionId = (rule, value, callback) => {
      if (!value && this.formData4.exceptionType == 1) {
        return callback(new Error("请选择转场原因"));
      } else {
        callback();
      }
    };
    let queueUpLineGroup = (rule, value, callback) => {
      if (!value && this.formData4.exceptionType == 1) {
        return callback(new Error("请选择生产线"));
      } else {
        callback();
      }
    };
    let turnNum = (rule, value, callback) => {
      if (!value && this.formData4.exceptionType == 1) {
        return callback(new Error("请输入转料量"));
      } else {
        callback();
      }
    };
    let overNum = (rule, value, callback) => {
      if (!value && this.formData4.exceptionType == 1) {
        return callback(new Error("请输入翻出量"));
      } else {
        callback();
      }
    };
    let engineeringId = (rule, value, callback) => {
      if (!value && this.formData4.exceptionType == 1) {
        return callback(new Error("请选择接收工程"));
      } else {
        callback();
      }
    };
    return {
      DownloadURL: Download,
      table: [
        { label: "订单编号", prop: "orderNo", status: true, width: "220" },
        { label: "物流号", prop: "code", status: true, width: "220" },
        { label: "结算方式", prop: "settleName", status: true, width: "120" },
        { label: "工程名称", prop: "engineeringName", status: true, width: "200" },
        { label: "车牌号", prop: "carNo", status: true, width: "auto" },
        { label: "生产站点", prop: "productionSite", status: true, width: "auto" },
        { label: "生产线", prop: "proLine", status: true, width: "150" },
        { label: "浇筑部位", prop: "structuralParts", status: true, width: "200" },
        { label: "产品名称", prop: "productName", status: true, width: "150" },
        { label: "转料站点", prop: "turnStationName", status: true, width: "120" },
        { label: "发货量", prop: "faceValue", status: true, width: "auto" },
        { label: "余料量", prop: "residueNum", status: true, width: "auto" },
        { label: "数据来源", prop: "dataType", status: true },
        { label: "处理类型", prop: "exceptionType", status: true, width: "auto" },
        { label: "回站时间", prop: "weightTime", status: true, width: "auto" },
        { label: "生产时间", prop: "proTime", status: true, width: "auto" },
        { label: "余料状态", prop: "surplusStatus", status: true, width: "auto" },
        { label: "备注", prop: "remark", status: true, width: "auto" },
        { label: "操作", prop: "", status: true, width: "150" },
      ],
      tableData: [],
      pagesType: 0,
      startTimDateEndTimDate: [new Date().Format("yyyy-MM-dd 00:00:00"), new Date().Format("yyyy-MM-dd 23:59:59")],
      tableLoading: false,
      tableParam: {
        page: 1,
        pageSize: 10,
      },
      total: 0,
      currenindex: 1,
      list2Info: {},
      proId: "",
      look3Type: false,
      radio: "",
      planList: [],
      engineeringIdList: [],
      turnStation: {},
      formData4: {},
      pointIdListArr: [],
      rules4: {
        exceptionType: [{ required: true, message: "请选择类型", trigger: "change" }],
        stationId: [{ validator: stationId, trigger: "change" }],
        transitionResionId: [{ validator: transitionResionId, trigger: "change" }],
        queueUpLineGroup: [{ validator: queueUpLineGroup, trigger: "change" }],
        turnNum: [{ validator: turnNum, trigger: "blur" }],
        overNum: [{ validator: overNum, trigger: "blur" }],
        engineeringId: [{ validator: engineeringId, trigger: "change" }],
        engineeringName: [{ required: true, message: "请输入" }],
        remark: [{ required: true, message: "请输入备注" }],
      },
      surplusPage2: 1,
      surplusTotal2: 0,
      surplusList2: [],
      dataTypeList: ["","ERP", "小票补录", "空票签收", "外协提交", "翻料处理","生产运输"],
      UserInfo: "",
      lineGroupList: [],
      isTurnStation: false,
      turnReasonList:[],
    };
  },
  watch: {
    startTimDateEndTimDate(val) {
      if (val?.length > 0) {
        this.tableParam.createTime = val[0];
        this.tableParam.updateTime = val[1];
      } else {
        this.tableParam.createTime = "";
        this.tableParam.updateTime = "";
      }
    },
  },
  async created() {
    //查询账号公司下所有站点
    this.UserInfo = await getUserInfo();
    this.pointIdListArr = await getUserAutList(true);
    this.tableParam = { ...this.tableParam, createTime: "", updateTime: "", carNo: "", surplusStatus: 1, stationId: "",structuralParts:"",proLine:"",productName:"" };
    this.tableParam.createTime = this.startTimDateEndTimDate[0] || "";
    this.tableParam.updateTime = this.startTimDateEndTimDate[1] || "";
    if (this.UserInfo.pointIds.length > 0) {
      this.tableParam.stationId = this.UserInfo.pointIds[0];
    } else {
      this.tableParam.stationId = this.pointIdListArr[0].id;
    }
    getDicType({
        code: "turnReason",
      }).then(res => {
         this.turnReasonList = res.data.items
      });
    // this.tableParam.productionSite = await getUserInfo()?.pointIds[0];
    this.gettableData();
  },
  methods: {
    cancle(row){
      this.$confirm('请确认是否取消?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '关闭',
        cancelButtonClass: 'bottom_all_two',
        confirmButtonClass: 'bottom_all',
        type: 'warning'
      })
        .then(() => {
          cancelHandle({proId:row.id}).then(res => {
        if(res.code == 1001) {
          this.$message.success("取消成功！");
          this.gettableData();
        }
      })
        })
        .catch(() => { });
    },
    queryLineByStation(stationId) {
      queryLineGroup({ stationId: stationId }).then(res => {
        if (res.code == 1001) {
          this.lineGroupList = res.data;
          this.lineGroupList.forEach(item => {
            let lineList = JSON.parse(item.lineName);
            item["lineList"] = lineList;
            item["name"] = lineList.map(item => item.name).join(",");
          });
        }
      });
    },
    getPlanPage(page) {
      this.surplusPage2 = page;
      const params = {
        page,
        pageSize: 5,
        stationId: this.formData4.stationId ? this.formData4.stationId : null,
        // engineeringId: this.formData4.engineeringId,
        engineeringName: this.formData4.engineeringName || "",
        structuralParts: this.formData4.structuralParts || "",
        productName: this.formData4.productName || "",
        pouringTime: this.formData4.pouringTime || "",
      };
      getPlanPage(params).then(res => {
        if (res && res.code === 1001) {
          this.surplusList2 = res.data.data;
          this.surplusTotal2 = res.data.totalRows;
        }
      });
    },
    submit3() {
      this.$refs.formData4.validate(valid => {
        if (valid) {
          if (this.formData4.exceptionType == 1 && ((this.formData4.stationId === this.list2Info.productionSiteId && !this.radio) || (this.list2Info.surplusStatus === 2 && !this.radio))) {
            this.$message.warning("请选择接收工程的计划");
            return;
          }
          if (this.formData4.exceptionType == 1) {
            const params = {
              proId: this.proId,
              // exceptionType: this.formData4.exceptionType,
              stationId: this.list2Info.productionSiteId,
              station: this.list2Info.productionSite,
              turnNum: this.formData4.turnNum,
              // overNum: this.formData4.overNum,
              engineeringId: this.radio.engineeringId,
              engineeringName: this.radio.engineeringName,
              turnStationId: this.radio.stationId || this.formData4.stationId,
              turnStationName: this.radio.stationName || this.formData4.station,
              // carNo: this.list2Info.carNo,
              turnPlanCode: this.radio.code,
              remark: this.formData4.remark,
              queueUpLineGroup: this.formData4.queueUpLineGroup,
              queueUpLine: this.formData4.queueUpLine,
              transitionResionId: this.formData4.transitionResionId,
              transitionResion: this.formData4.transitionResion,
            };
            saveTransferMaterials(params).then(res => {
              if (res.code === 1001) {
                this.$message.success("操作成功");
                this.gettableData();
                this.look3Type = false;
                this.surplusVisible = false;
              }
            });
          } else if (this.formData4.exceptionType == 4) {
            const params2 = {
              proId: this.proId,
              overNum: this.formData4.overNum,
              remark: this.formData4.remark,
            };
            saveOverMaterials(params2).then(res => {
              if (res.code === 1001) {
                this.$message.success("操作成功");
                this.gettableData();
                this.look3Type = false;
                this.surplusVisible = false;
              }
            });
          } else {
            const params3 = {
              proId: this.proId,
              exceptionType: this.formData4.exceptionType,
              remark: this.formData4.remark,
            };
            saveOther(params3).then(res => {
              if (res.code === 1001) {
                this.$message.success("操作成功");
                this.gettableData();
                this.look3Type = false;
                this.surplusVisible = false;
              }
            });
          }
        }
      });
    },
    handleClick(data) {
      this.proId = data.id;
      this.list2Info = data;
      this.look3Type = true;
      this.radio = "";
      this.planList = [];
      this.surplusList2 = [];
      this.surplusTotal2 = 0;
      console.log(data);
      this.isTurnStation = this.tableParam.stationId == data.turnStationId ? true : false; //标记是否为转料站点
      if (data.surplusStatus === 2) {
        this.formData4 = {
          exceptionType: data.exceptionType,
          stationId: data.turnStationId,
          station: data.turnStationName,
          turnNum: data.turnNum,
          residueNum: data.residueNum,
          overNum: data.turnNum,
          remark: data.remark,
          engineeringId: data.engineeringId,
          engineering: data.engineeringName,
        };
        // console.log(this.formData4);
        // if (data.turnStationId) {
        //   this.getEngineeringIdListFun(data.turnStationId);
        // }
        this.queryLineByStation(this.formData4.stationId);
        return;
      }
      this.formData4 = {
        exceptionType: data.exceptionType,
        stationId: data.productionSiteId,
        station: data.productionSite,
        turnNum: data.residueNum,
        residueNum: data.residueNum,
        overNum: data.exceptionType == 4 ? data.overNum : data.residueNum,
        remark: data.remark,
        engineeringId: data.engineeringId,
        engineering: data.engineeringName,
        queueUpLine: data.queueUpLine,
        queueUpLineGroup: data.queueUpLineGroup,
        transitionResionId: data.transitionResionId,
        transitionResion: data.transitionResion,
      };
      this.queryLineByStation(this.formData4.stationId);
      //计划列表
      this.formData4.pouringTime =new Date().Format("yyyy-MM-dd 00:00:00")
     
      //   if (data.productionSiteId) {
      //     this.getEngineeringIdListFun(data.productionSiteId);
      //   }
      /**
       * @Description: 已处理的数据通过turnPlanCode查询订单
       * @param {*}
       * @Author: wangwangwang
       */
      if (this.currenindex === 3 && data.exceptionType == 1) {
        const params = {
          turnPlanCode: data.turnPlanCode,
        };
        this.surplusList2 = [];
        this.surplusTotal2 = 0;
        getPlanByCode(params).then(res => {
          if (res.code === 1001 && res.data) {
            this.surplusList2.push(res.data);
            this.surplusTotal2 = 1;
          }
        });
      } else {
        this.getPlanPage(1)
      }
    },
    /**查询站点的：接收工程方list */
    getEngineeringIdListFun(e, el) {
      if (!el) return;
      this.turnStation.turnStationId = e;
      this.turnStation.turnStationName = el;
      this.engineeringIdList = [];
      get_engineering_list({ stationId: e, station: el }).then(res => {
        this.engineeringIdList = res.data;
      });
    },
    choose(num) {
      this.currenindex = num;
      this.tableParam.surplusStatus = num;
      this.gettableData();
    },
    gettableData() {
      this.tableLoading = true;
      querySurplusLogisticsPage(this.tableParam).then(res => {
        this.tableLoading = false;
        if (res.code === 1001) {
          this.tableData = res.data.data;
          this.total = res.data.totalRows;
        }
      });
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
    /*重置数据,此方法必须存在，并且方发只重置条件*/
    init() {
      this.tableParam.page = 1;
      this.tableParam.pageSize = 10;
      this.tableParam.carNo = "";
      this.tableParam.structuralParts="",
      this.tableParam.proLine="",
      this.tableParam.productName=""
      this.tableParam.productionSite = "";
      this.tableParam.stationId = "";
      (this.startTimDateEndTimDate = [new Date().Format("yyyy-MM-dd 00:00:00"), new Date().Format("yyyy-MM-dd 23:59:59")]), this.initData();
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}
.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
.tabtop {
  width: 381px;
}
</style>
  